"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workRegistrationNumber = exports.workName = exports.schoolAddress = exports.other = exports.expectedLeaveDate = exports.educationTypeOptions = exports.educationType = exports.educationConfig = exports.EducationDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _addressConfig = require("../Address/addressConfig");

var _dateConfig = require("../../fields/Date/dateConfig");

var _radioConfig = require("../../fields/Radio/radioConfig");

var _textfieldConfig = require("../../fields/Textfield/textfieldConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _textfieldConfig.TextfieldDefinition;
});

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _radioConfig.RadioDefinition;
});

var DateDefinition = _flowRuntime["default"].tdz(function () {
  return _dateConfig.DateDefinition;
});

var AddressDefinition = _flowRuntime["default"].tdz(function () {
  return _addressConfig.AddressDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var educationTypeOptions = {
  sixthForm: 'Full-time sixth form or college',
  workBasedEducation: 'Work-based Education',
  notInEducation: 'Not in Education',
  other: 'Other'
};
exports.educationTypeOptions = educationTypeOptions;
var educationType = {
  key: 'educationType',
  type: 'radio',
  title: 'Please select the option which reflects the kind of education you are currently in',
  items: [{
    key: educationTypeOptions.sixthForm,
    value: educationTypeOptions.sixthForm
  }, {
    key: educationTypeOptions.workBasedEducation,
    value: educationTypeOptions.workBasedEducation
  }, {
    key: educationTypeOptions.notInEducation,
    value: educationTypeOptions.notInEducation
  }, {
    key: educationTypeOptions.other,
    value: educationTypeOptions.other
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.educationType = educationType;
var schoolAddress = {
  key: 'schoolAddress',
  type: 'address',
  label: 'Please include the school address',
  inheritedFieldValidation: [{
    validation: [{
      required: true
    }],
    fieldKey: 'line1'
  }, {
    validation: [{
      required: true
    }],
    fieldKey: 'town'
  }, {
    validation: [{
      required: true
    }, {
      postcode: true
    }],
    fieldKey: 'postcode'
  }],
  validation: [],
  options: {
    country: false,
    name: true
  }
};
exports.schoolAddress = schoolAddress;
var expectedLeaveDate = {
  key: 'expectedLeaveDate',
  title: 'Please include the date you expect to leave',
  type: 'date',
  validation: [{
    required: true
  }]
};
exports.expectedLeaveDate = expectedLeaveDate;
var workName = {
  maxLength: 100,
  key: 'workName',
  label: 'Name',
  type: 'text',
  validation: [{
    required: true
  }]
};
exports.workName = workName;
var workRegistrationNumber = {
  inputmode: 'numeric',
  key: 'workRegistrationNumber',
  label: 'Registration Number',
  maxLength: 100,
  normalize: 'number',
  pattern: '[0-9]*',
  type: 'text',
  validation: [{
    required: true
  }]
};
exports.workRegistrationNumber = workRegistrationNumber;
var other = {
  key: 'other',
  label: 'Other',
  maxLength: 200,
  type: 'text',
  validation: []
};
exports.other = other;
var educationConfig = {
  type: 'education',
  fields: [educationType // @TODO: NOVA-7059: disabled to prevent backend validation blocking submission if fields are conditionally hidden in the frontend
  // expectedLeaveDate,
  // workName,
  // workRegistrationNumber,
  // other,
  ],
  subComponents: [// @TODO: NOVA-7059: disabled to prevent backend validation blocking submission if component is conditionally hidden in the frontend
    // schoolAddress
  ]
};
exports.educationConfig = educationConfig;

var EducationDefinition = _flowRuntime["default"].type("EducationDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("education")))));

exports.EducationDefinition = EducationDefinition;